import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { resetGroundTypeEffects } from 'services/API/Exploitation';
import { displayErrorMessage } from 'utils/tools_functions';
import { sendEvent } from 'utils/Event';

import DataGridGroundTypeEffects from '../Cooperative/DataGridGroundTypeEffects';
import { ThemeProvider } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { customDialogTheme } from 'assets/styles/themes/Dialog/generic_dialog_mui';
import './groundTypeEffect.style.scss';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';

const GroundTypeEffectsDataGridExploitation = ({
  exploitation,
  setExploitation,
  from,
  cultures,
  groundTypes,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [exploit, setExploit] = useState(exploitation);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const exploitId = exploit?.id ?? +localStorage.getItem('exploitation');

  const { isOrganic } = useToggleSwitch(
    from,
    'groundTypesEffects',
    () => {},
    exploitId,
    null,
    null,
  );

  useEffect(() => {
    loadData();
    return () => {
      sendEvent('cancelHttpRequest');
    };
  }, []);

  const loadData = () => {
    if (localStorage.getItem('exploitation')) {
      setExploitation(isOrganic, +localStorage.getItem('exploitation'), false, 'rotation')
        .then((resp) => setExploit(resp.data.data))
        .catch((err) => toast.error(err.data));
    } else {
      toast.info(t('message.selectExploitation'));
      navigate('/exploitation');
    }
  };

  const resetAllGroundTypeEffects = () => {
    setOpenDeleteDialog(false);
    resetGroundTypeEffects(exploit, isOrganic)
      .then(() => {
        toast.success(t('success.effectsReset', { name: exploit.name }));
        setExploitation(isOrganic, exploitId);
      })
      .catch(() => toast.error(displayErrorMessage('ERR_REINIT_EFFECT')));
  };

  const renderDeleteDialog = () => {
    return (
      <ThemeProvider theme={customDialogTheme}>
        <Dialog maxWidth="md" open={openDeleteDialog}>
          <DialogTitle>{t('common.warning')}</DialogTitle>
          <DialogContent dividers>
            <h3>{t('button.resetGroundTypeEffects')}</h3>
            <p>{t('message.resetGroundTypeEffects')}</p>
            <p>{t('common.continueQuestion')}</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={resetAllGroundTypeEffects}>
              {t('common.confirm')} <DoneIcon />
            </Button>
            <Button onClick={() => setOpenDeleteDialog(false)}>
              {t('common.no')} <ClearIcon />
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  const handleResetGroundTypeEffects = () => {
    setOpenDeleteDialog(true);
  };
  return (
    <div>
      <DataGridGroundTypeEffects
        from={from}
        cultures={cultures?.data?.filter((culture) => culture.isCustomized === true)}
        ownerId={exploitId}
        refreshData={setExploitation}
        groundTypes={groundTypes}
        handleResetGroundTypeEffects={handleResetGroundTypeEffects}
      />
      {renderDeleteDialog()}
    </div>
  );
};

export default GroundTypeEffectsDataGridExploitation;
